import request from "./request";

export const login = (data) => {
	return request({
		url: `/users/login`,
		method: 'post',
		data: data
	});
};
